<template>
    <div>
        <div class="col-12 override-padding">
            <div>
                <div class="res_offcanvas_header col-12 text-align-right" style="padding-bottom: 10px;">
                    <a @click="openAddSubscriptionModal" class="linkable" >Add License</a>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="col-12 override-padding">
            <div class="res_offcanvas_header pur_heading_1 text-left">Purchase History</div>
            <div class="res_offcanvas_header pur_heading_2 text-left">
                <!--a class="print_icons" href="javascript:void(0)" @click="goToPrint" v-if="orderItems.length > 0">
                    <i class="fa fa-print"></i>
                </a-->
            </div>
            <div class="clearfix"></div>
            <div v-if="orderItems.length > 0">
                <div v-for="(item, index) in orderItems" :key="index">
                    <div class="res_offcanvas_content pur_content_1 text-left">
                        {{ item.unitType }}
                    </div>
                    <div class="res_offcanvas_content pur_content_2 text-left">
                        {{ item.noOfUnits }}
                    </div>
                    <div class="res_offcanvas_content pur_content_3 text-left">
                        ${{ item.totalAmount }}
                    </div>
                    <div class="res_offcanvas_content pur_content_4 text-left">
                        {{ item.orderCreatedAt | formatExpirationDate }}
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div v-else>
                <div class="text-red text-center m-4">No Purchase History Found</div>
            </div>
        </div>

        <RenewAccountLicense
              :isRenewModalVisible="isRenewModalVisible" 
              :accountId="accountId"
              @close="closeRenewModal"
              ref="renew_account_license" 
             />

        <AddNewAccountLicense
              :isAddNewAccountLicenseModalVisible="isAddNewAccountLicenseModalVisible" 
              :accountId="accountId"
              @close="closeAddSubscriptionModal"
              ref="add_new_account_license" 
             />

    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import axios from 'axios';
import router from '../../router/index.js';
import RenewAccountLicense from './renew_account_license.vue';
import AddNewAccountLicense from './add_new_account_license.vue';

Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

export default {
    props: ['accountId', 'readOnly'],
    data() {
        return {
            orderItems: [],
            currentPlan: {},
            isRenewModalVisible: false,
            isAddNewAccountLicenseModalVisible: false,
        }
    },
    components: {
        RenewAccountLicense,
        AddNewAccountLicense
    },
    methods: {
        openRenewModal() {
            this.isRenewModalVisible = true;
            this.accountId = this.accountId;
            this.$refs.renew_account_license.loadInitialData();
        },
        closeRenewModal() {
            this.isRenewModalVisible = false;
        },
        goToPrint(){
            router.push('/print-account-license/' + this.accountId)
        },
        accountPurchaseHsitory() {
            axios('/enterprise-admin/account-orders/' + this.accountId,
            {
                method: 'GET'
                
            },
            )
            .then(response => {
                this.loading = false;
                this.orderItems = response.data.orderItems;
                this.currentPlan = response.data.currentPlan;    
            })
            .catch(error => {
                console.log(error)
            });
        },
        openAddSubscriptionModal() {
            this.isAddNewAccountLicenseModalVisible = true;
            this.$refs.add_new_account_license.loadInitialData();
        },
        closeAddSubscriptionModal() {
            this.isAddNewAccountLicenseModalVisible = false;
        }
    },
    created() {
        this.accountPurchaseHsitory();
    }
}
</script>
<style scoped>
.license_heading_1 { width: 60%; }
.license_heading_2 { width: 30%; }
.license_heading_3 { width: 10%; }
.pur_heading_1 { width: 90%; }
.pur_heading_2 { width: 10%; }
.pur_content_1 { width: 55%; }
.pur_content_2 { width: 15%; }
.pur_content_3 { width: 12%; }
.pur_content_4 { width: 18%; }
.res_offcanvas_header { float: left; font-weight: 900; cursor: pointer; margin-top: 15px; }
.res_offcanvas_content { float: left; margin: 5px 0; font-weight: 500; }
.planBtn, .planBtn:focus, .planBtn:active, .planBtn:hover {
  color: #000 !important;
  background: #a1ee95 !important;
  border: 1px solid #a1ee95 !important;
  width: 150px;
}
.linkable { color: #00acee !important; text-decoration: underline !important; font-weight: 900; cursor:pointer; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }
.border-bottom-visible { border-bottom: 1px solid #ccc; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.lic_heading_1 { width: 70%; }
.lic_heading_2 { width: 30%; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/license_tab.vue